<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// 创建 <style> 标签
const style = document.createElement('style');
style.type = 'text/css';

// CSS 代码
const css = `
.Lo-Amazon:hover {
    background-color: #111; /* 鼠标悬停时略微加深 */
    
}
.Lo-Amazon:hover .Lo-Amazon-Button-Content{
    color:#F7B000;
}
.Lo-Amazon:hover svg {
    fill: #F7B000;
}
.Lo-Amazon::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 150%;
    width: 200%;
    background-image: linear-gradient(90deg, transparent, #F7B000, transparent); 
    transform: skew(-20deg);
    opacity: 0.7;
    z-index: 1;
    animation: shine2 5s cubic-bezier(.01, .56, 1, 1) infinite;
}

.Lo-Amazon:hover::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 150%;
    width: 200%;
    background-image: linear-gradient(90deg, transparent, #F7B000, transparent); 
    transform: skew(-20deg);
    opacity: 0.7;
    animation: shine2 5s cubic-bezier(.01, .56, 1, 1) infinite;
}

@keyframes shine2 {
    20% { left: -200%; }
    100% { left: -200%; }
}
`;

// 将 CSS 代码添加到 <style> 标签中
style.appendChild(document.createTextNode(css));

// 将 <style> 标签插入到 <head> 标签中
document.head.appendChild(style);
